import { db } from '../FirebaseConfig';
import { collection, setDoc, getDocs, query, where, doc, deleteDoc } from '@firebase/firestore';
import { DATABASE_COLLECTIONS } from '../constants/DatabaseCollections';
import { deleteProjectById } from './Projects';
import { deleteUserAccount } from '../Authentication';
import { auth } from '../FirebaseConfig';

export const createUser = async (uid, email, createdAt, authProvider) => {
    const user = {
        uid: uid,
        email: email,
        createdAt: createdAt,
        authProvider: authProvider
    }

    const userExist = await checkIfUserExistWithEmail(email)

    const docRef = doc(db, DATABASE_COLLECTIONS.USERS, uid)
    if (!userExist) {
        await setDoc(docRef, user)
            .catch(err => {
                throw new Error(err);
            })

    } else {
        throw 'Utilisateur déjà existant'
    }
}

export const deleteUserDoc = async () => {
    const userId = auth.currentUser.uid;

    let docRef = doc(db, DATABASE_COLLECTIONS.USERS, userId)

    const sendRequest = await deleteDoc(docRef)
        .then(() => {
            return
        })
        .catch(err => {
            throw new Error(err);
        })

    return sendRequest;
}
export const checkIfUserExistWithEmail = async (email) => {
    let collectionRef = collection(db, DATABASE_COLLECTIONS.USERS)

    let q = query(collectionRef, where('email', '==', email));
    let querySnapshot = await getDocs(q);
    let userExist = false;

    querySnapshot.forEach((doc) => {
        let docEmail = doc.data().email

        if (email === docEmail) {
            userExist = true
        }
    });

    return userExist
}

export const deleteAllDatas = async (projectsArr = []) => {
    try {
        projectsArr.map(project => {
            deleteProjectById(project.projectId, project.splits)
        })
    } catch (error) {
        throw new Error(error)
    }

}

export const deleteAccount = async (projectsArr = []) => {
    const deleteDatas = await deleteAllDatas(projectsArr)
        .then(() => true)
        .catch(() => {
            throw new Error()
        })

    if (!deleteDatas) {
        throw new Error()
    }


    // Delete user doc on firestore
    const deleteUser = await deleteUserDoc()
        .then(() => true)
        .catch(() => {
            throw new Error()
        })

    if (!deleteUser) {
        throw new Error()
    }

    // Delete account firebase auth
    const deleteAccount = await deleteUserAccount()
        .then(() => true)
        .catch(() => {
            throw new Error()
        })

    if (!deleteAccount) {
        throw new Error()
    }
}